import { render, staticRenderFns } from "./customSlider.vue?vue&type=template&id=1dfa9628&scoped=true&"
import script from "./customSlider.vue?vue&type=script&lang=js&"
export * from "./customSlider.vue?vue&type=script&lang=js&"
import style0 from "./customSlider.vue?vue&type=style&index=0&id=1dfa9628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfa9628",
  null
  
)

export default component.exports